/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Table } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import CreateEditResourceModal from "./CreateEditModal";
import { showNotification } from "../../../../utils/notification";

const Resource = ({ sectionResources, courseId, sectionId, ROOT_URL }) => {
  const [resources, setResources] = useState([]);
  const [isCreateResourceModalOpen, setIsCreateResourceModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const handleResourceDelete = (resourceId) => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/resource/delete`, {
        resourceId,
        courseId,
        sectionId
      })
      .then((res) => {
        const { updatedResources } = res.data;
        setResources(updatedResources);
        showNotification(
          "Resource deleted Successfully",
          "Resource deleted Successfully",
          "success"
        );
      })
      .catch(() => {
        showNotification("Internal Server Error", "Internal Server Error", "error");
      });
  };

  const handleCreateEditResource = (values) => {
    if (initialValues?._id !== undefined) {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/resource/edit`, {
          resourceParams: values,
          resourceId: initialValues._id,
          courseId,
          sectionId
        })
        .then((res) => {
          const { updatedResources } = res.data;
          setResources(updatedResources);
          setIsCreateResourceModalOpen(false);
          showNotification(
            "Resource edited Successfully",
            "Resource edited Successfully",
            "success"
          );
        })
        .catch(() => {
          showNotification("Internal Server Error", "Internal Server Error", "error");
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/resource/create`, {
          resourceParams: values,
          courseId,
          sectionId
        })
        .then((res) => {
          const { updatedResources } = res.data;
          setResources(updatedResources);
          setIsCreateResourceModalOpen(false);
          showNotification(
            "Resource created Successfully",
            "Resource created Successfully",
            "success"
          );
        })
        .catch(() => {
          showNotification("Internal Server Error", "Internal Server Error", "error");
        });
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title"
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link"
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category"
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="section_resources_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            flexWrap: "wrap"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setInitialValues(row);
              setIsCreateResourceModalOpen(true);
            }}
          >
            Edit
          </Button>
          <Button
            type="primary"
            danger
            onClick={() => {
              handleResourceDelete(row._id);
            }}
          >
            Delete
          </Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    setResources(sectionResources);
  }, []);

  return (
    <div>
      <div style={{ marginBottom: "1em" }}>
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({});
            setIsCreateResourceModalOpen(true);
          }}
        >
          {" "}
          Create New Resource
        </Button>
      </div>
      <Table
        columns={columns}
        bordered
        pagination={false}
        dataSource={resources}
        scroll={{ x: "max-content" }}
      />
      {isCreateResourceModalOpen === true && (
        <CreateEditResourceModal
          isModalOpen={isCreateResourceModalOpen}
          setIsModalOpen={setIsCreateResourceModalOpen}
          initialValues={initialValues}
          isEdit={initialValues?._id !== undefined}
          handleCreateEdit={handleCreateEditResource}
        />
      )}
    </div>
  );
};

export default Resource;
